import { ScrollTo as scrollTo } from 'belle-js'

const getFirstErrorField = (nodes) => {
  let firstErrorField = nodes.item(0)
  Array.from(nodes).forEach((element) => {
    if (firstErrorField.offsetTop > element.offsetTop) {
      firstErrorField = element
    }
  })
  return firstErrorField
}

export const scrollToFirstError = (timeout = 250) => {
  if (!window || !document) return

  setTimeout(() => {
    // Scroll to first error
    const headerHeight = 50
    const windowScrollPos = window.scrollY || window.pageYOffset
    const errorFields = document.getElementsByClassName('formfield is-error')
    const firstErrorField = getFirstErrorField(errorFields)
    if (firstErrorField) {
      const yPos = firstErrorField.getBoundingClientRect().top
      scrollTo(yPos + windowScrollPos - headerHeight - 50)
    }
  }, timeout)
}
export default scrollToFirstError



// WEBPACK FOOTER //
// ./src/utils/formUtils.js